import React from 'react';
import QRCode from "qrcode.react";
import { useState, useEffect } from 'react'
import { api } from "../../../services/api"
import { useParams } from "react-router"
import { Container } from './style'
import Button from '../../../components/Button'
import { FiLink } from "react-icons/fi";
function Qrcodegen() {

  let{id} = useParams()

  const [retailers_id, setRetailers_id] = useState('')
  // const [name, setName] = useState('')
  
  const loadid = async () => {
    const response = await api.get(`/clients/show/${id}`)
    // setName(response.data.name)
    setRetailers_id(response.data.name.retailers_id)
  }
  useEffect(() => {
    loadid()
// eslint-disable-next-line
  }, [])

  
  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `qrcode.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  
  return(  
  <Container>
    <div className='qrdiv'>
      <h1>Compartilhe seu link de referência</h1>
      <Button onClick={downloadQRCode}>Salvar QRCode</Button>
    </div>
    <div className='qrimg'>
      <QRCode
          id="qr-gen"
          value={`http://https://struct-hotel-api.herokuapp.com/sign_up/${retailers_id}`}
          size={200}
          level={"H"}
          includeMargin={true}
          bgColor={"transparent"}

        />
      <a href={`https://struct-hotel-api.herokuapp.com/sign_up/${retailers_id}`}><FiLink size='14px'/> https://struct-hotel-api.herokuapp.com/sign_up/{retailers_id}</a>
    </div>
  </Container>
  )
} 
export default Qrcodegen